export const blogPosts = [
  {
    id: 1,
    title: "حماية المستهلك في المملكة العربية السعودية",
    description: "تعرف على حقوق المستهلك الأساسية والأنظمة السعودية التي تحميه من الممارسات التجارية الضارة",
    excerpt: "تعرف على حقوق المستهلك الأساسية والأنظمة السعودية التي تحميه من الممارسات التجارية الضارة",
    image: "/images/blog/2.png",
    date: "ديسمبر 2025",
    readTime: "12 دقيقة",
    author: "إشراف شركة أنس للمحاماة",
    path: "/Blog1"
  },
  {
    id: 2,
    title: "الاحتيال الإلكتروني في المملكة العربية السعودية",
    description: "تعرف على أنواع الاحتيال الإلكتروني وكيفية الحماية منه في المملكة العربية السعودية",
    excerpt: "دليل شامل لتقسيم الميراث في المملكة العربية السعودية...",
    image: "/images/blog/Blog32.png",
    date: "يوليو 2025",
    readTime: "5 دقائق",
    author: "إشراف شركة أنس للمحاماة",
    path: "/Blog2"
  },
  {
    id: 3,
    title: "جريمة الابتزاز في المملكة العربية السعودية",
    description: "تعرف على ماهية الابتزاز، أنواعه، والعقوبات المترتبة عليه وفقاً للأنظمة المعمول بها في المملكة",
    excerpt: "تعرف على أحدث التحديثات القانونية في المملكة العربية السعودية...",
    image: "/images/Home/sec3 home.png",
    date: "يوليو 2025",
    readTime: "4 دقائق",
    author: "إشراف شركة أنس للمحاماة",
    path: "/Blog3"
  },
  {
    id: 4,
    title: "الأدلة الرقمية | ثورة جديدة في الإثبات القانوني",
    description: "تعرف على مفهوم الأدلة الرقمية، وأهميتها، وشروط قبولها، والتحديات التي تواجهها",
    excerpt: "تعرف على مفهوم الأدلة الرقمية، وأهميتها، وشروط قبولها، والتحديات التي تواجهها",
    image: "/images/Home/sec6 home.png",
    date: "ديسمبر 2025",
    readTime: "20 دقيقة",
    author: "إشراف شركة أنس للمحاماة",
    path: "/Blog4"
  },
  {
    id: 5,
    title: "دليلك لعقود العمل وحقوق الموظف في النظام السعودي",
    description: "تعرف على أبرز ملامح عقود العمل في النظام السعودي، وحقوق الموظف والضمانات القانونية التي يوفرها النظام",
    excerpt: "تعرف على أبرز ملامح عقود العمل في النظام السعودي، وحقوق الموظف والضمانات القانونية التي يوفرها النظام",
    image: "/images/صور الموقع (1)/صورة واتساب بتاريخ 2025-09-02 في 00.31.12_4d4e2450.jpg",
    date: "فبراير 2025",
    readTime: "15 دقيقة",
    author: "إشراف شركة أنس للمحاماة",
    path: "/Blog5"
  },
  {
    id: 6,
    title: "التعديلات الجديدة في نظام العمل",
    description: "تعرف على أبرز التعديلات الجديدة في نظام العمل السعودي التي تشمل 38 مادة معدلة و7 مواد ملغاة ومادتين جديدتين",
    excerpt: "تعرف على أبرز التعديلات الجديدة في نظام العمل السعودي التي تشمل 38 مادة معدلة و7 مواد ملغاة ومادتين جديدتين",
    image: "/images/blog/Blog25.png",
    date: "ديسمبر 2025",
    readTime: "18 دقيقة",
    author: "إشراف شركة أنس للمحاماة",
    path: "/Blog6"
  }
];

// دالة للحصول على أحدث 3 مقالات للعرض في الهوم
export const getLatestBlogPosts = (count = 3) => {
  return blogPosts.slice(0, count);
};

// دالة للحصول على مقالة محددة بواسطة ID
export const getBlogPostById = (id) => {
  return blogPosts.find(post => post.id === id);
};
